export default "__VITE_ASSET__537f9c7f__"